import { useQuery } from '@apollo/client';

import {
  GetAscProjectApprovalStatusQuery,
  GetAscProjectApprovalStatusQueryVariables,
  GET_ASC_PROJECT_APPROVAL_STATUS,
} from '@neo.tax/shared';

import { useAscContext } from '../context';

type AscProjectApprovalStatusResult = GetAscProjectApprovalStatusQuery['getAscProject']['approvalStatus'];

export const useAscProjectApprovalStatus = (
  ascProjectId: string,
  options?: { skip?: boolean },
): {
  approvalStatus: AscProjectApprovalStatusResult | null;
  loading: boolean;
  error: Error | undefined;
} => {
  const { fiscalYearId, periodName } = useAscContext();
  const { data, error, loading } = useQuery<
    GetAscProjectApprovalStatusQuery,
    GetAscProjectApprovalStatusQueryVariables
  >(GET_ASC_PROJECT_APPROVAL_STATUS, {
    variables: { ascProjectId, fiscalYearId, periodName },
    skip: options?.skip ?? false,
  });

  const approvalStatus = data?.getAscProject?.approvalStatus;

  return { approvalStatus, loading, error };
};
